export default "__VITE_ASSET__BaCFRiRx__"